import { useEffect } from "react";
import useAppMain from "src/hooks/useAppMain";
import { CLIENT_ROUTES, CLIENT_TAB_LIST, formatter } from "src/utils/constants";
import { Button, Flex, Text, Box, Input, useMantineTheme } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useScheduleEventContext } from "src/api/context/ScheduleEventContext";
import { IconGym } from "src/screens/My_Calendar/ScheduleEvent/EventsList/ListItem";
import { FaMinus, FaPlus } from "react-icons/fa6";

const btnCss = {
  background: "#C3C3C3",
  color: "#8C8C8C",
  borderRadius: 10,
  height: 50,
  fontSize: 20,
  width: 50,
  label: {
    overflow: "visible",
  },
  padding: 12,
};

function ShoppingCart() {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  useAppMain(CLIENT_TAB_LIST.SHOPPING_CART, true);
  const { locationService, quantity, setQuantity, privateSession } =
    useScheduleEventContext();
  const { organizationService } = locationService || {};
  const { session } = privateSession || {};
  const _cost =
    (locationService ? locationService.cost : privateSession?.cost) || 0;
  const _imgUrl = locationService ? locationService.imgUrl : session?.imageUrl;
  const _name = locationService ? organizationService?.name : session?.name;

  useEffect(() => {
    if (!locationService && !privateSession) {
      navigate(-1);
    }
  }, []);

  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleIncrease = () => {
    setQuantity(quantity + 1);
  };

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newQuantity = parseInt(event.currentTarget.value, 10);
    if (!isNaN(newQuantity) && newQuantity >= 1) {
      setQuantity(newQuantity);
    }
  };

  const handleNav = () => {
    navigate(`/${CLIENT_ROUTES.CHECKOUT}`);
  };

  return (
    <Flex
      direction={"column"}
      justify={"space-between"}
      sx={{ height: "100%" }}
    >
      <Box>
        <Text fw={600} size={18} color={theme.colors.secondaryTextColor[6]}>
          Purchase Credits
        </Text>

        <Box
          mt={"md"}
          sx={{
            background: theme.colors.primary[6],
            borderRadius: 8,
          }}
        >
          <Box sx={{ padding: "8px 12px" }}>
            <Flex
              justify={"space-between"}
              sx={{ borderBottom: `1px solid #DDDDDD`, paddingBottom: 8 }}
            >
              <Flex align={"center"} gap={"xs"}>
                {IconGym(theme, _imgUrl || "")}
                <Box style={{ color: theme.colors.primaryTextColor[6] }}>
                  <Text size={18}>{_name}</Text>
                </Box>
              </Flex>

              <Text size={18} color={theme.colors.primaryTextColor[6]}>
                {formatter.format(_cost)}
              </Text>
            </Flex>
          </Box>
        </Box>

        <Flex mt={"xs"} gap={"xs"} align={"center"}>
          <Button
            onClick={handleDecrease}
            size="sm"
            sx={btnCss}
            disabled={quantity === 1}
          >
            <FaMinus
              color={
                quantity > 1 ? theme.colors.primaryTextColor[6] : undefined
              }
            />
          </Button>
          <Input
            value={quantity.toString()}
            onChange={handleQuantityChange}
            sx={{
              input: {
                height: 50,
                textAlign: "center",
                backgroundColor: theme.colors.primary[6],
                border: theme.colors.primary[6],
                color: theme.colors.primaryTextColor[6],
              },
              flex: 1,
            }}
          />
          <Button onClick={handleIncrease} size="sm" sx={btnCss}>
            <FaPlus color={theme.colors.primaryTextColor[6]} />
          </Button>
        </Flex>
      </Box>

      <Button m={"5px 0"} fullWidth loading={false} onClick={handleNav}>
        Continue to Checkout {formatter.format(quantity * _cost)}
      </Button>
    </Flex>
  );
}

export default ShoppingCart;
